import { useEffect, useState } from 'react';
import { RouteComponentProps, useNavigate } from '@reach/router';
import { useDispatch } from 'react-redux';
import { clearPackageForm } from 'reducers/misc';
import { FreeTrialSubscriptionParser } from './models';
import FormHeader from 'components/formHeader/FormHeader';
import Page from 'components/shared/Page';
import SchoolDetailsForm from 'components/schoolDetailsForm/SchoolDetailsForm';
import ProfileDetailsForm from 'components/profileDetailsForm/ProfileDetailsForm';
import { MembershipOptInfoForm } from 'components/membershipOptInfoForm/MembershipOptInfoForm';
import ConfirmationBox from 'components/confirmationBox/ConfirmationBox';
import { AppPath } from 'appConstants';
import CheckMark from 'images/Icon_Complete.png';

const SUCCESS_MESSAGE = {
  title: 'Congratulations!',
  subTitle: 'You have successfully submitted your trial request',
  message:
    'Someone from our team will notify you once your trial has been activated.',
  buttonText: 'Sign in',
};

const SubscribeFreeTrial: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeStep, setActiveSet] = useState<number>(1);

  const [subscriptionIsComplete, setSubscriptionIsComplete] = useState(false);

  useEffect(() => {
    return () => {
      //clear choose free trial package form
      dispatch(clearPackageForm());
    };
  }, []);

  return (
    <Page
      isPublic
      className={'SubscribePage'}
      redirectPath={AppPath.NEW_FREE_TRIAL}
      redirectParams={false}
    >
      {subscriptionIsComplete ? (
        <div className="Success">
          <div className="ConfirmationBoxContainer NewFreeTrial">
            <ConfirmationBox
              {...SUCCESS_MESSAGE}
              buttonOnClick={() => navigate(AppPath.SIGN_IN)}
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="SubcriptionAdditionalHeaderWrapper">
            <div className="SubcriptionAdditionalHeader WidthContent HeightContent">
              <h2>Get Set to explore your school trial...</h2>

              <ul>
                <li>
                  <img src={CheckMark} /> 14 day free trial
                </li>
                <li>
                  <img src={CheckMark} /> Access for all staff
                </li>
                <li>
                  <img src={CheckMark} /> Access to 2 lesson plans and UoW for
                  each unit
                </li>
                <li>
                  <img src={CheckMark} /> Access to curriculum mapping and
                  assessment tools
                </li>
                <li>
                  <img src={CheckMark} /> No obligation
                </li>
              </ul>
            </div>
          </div>
          <div className="PageContent WidthContent NewSubscriptionPage SubscriptionFreeTrial">
            <FormHeader
              activeStep={activeStep}
              numOfSteps={3}
              title={
                FreeTrialSubscriptionParser.getPageHeaderInfo(activeStep).title
              }
              nextStep={
                FreeTrialSubscriptionParser.getPageHeaderInfo(activeStep)
                  .nextStep
              }
            />
            {activeStep === 1 && (
              <>
                <MembershipOptInfoForm onSubmit={() => setActiveSet(2)} />
              </>
            )}
            {activeStep === 2 && (
              <SchoolDetailsForm 
                onSubmit={() => setActiveSet(3)} 
                hideSummaryPanel={true}
              />
            )}
            {activeStep === 3 && (
              <ProfileDetailsForm
                onSubmit={() => {
                  setSubscriptionIsComplete(true);
                }}
                hideSummaryPanel={true}
              />
            )}
          </div>
        </div>
      )}
    </Page>
  );
};

export default SubscribeFreeTrial;
